<template>
  <footer class="bg-black text-white relative bottom-0 w-full">
    <div class="max-w-6xl mx-auto py-10 flex flex-wrap flex-col justify-between sm:flex-row">
      <div id="address" class="text-center md:text-start">
        <div class="mb-5 text-2xl text-(--main-color-400)">Nous Trouver</div>
        <div class="addr">Place Stanislas, centre</div>
        <div class="city mb-3">54000 Nancy</div>
        <div class="contact mb-3">
          <div class="mail">arthur.hakobian1@gmail.com</div>
          <div class="tel">07 82 87 05 96</div>
        </div>
        <div class="socials">
          <a class="mr-3" href="#" aria-label="Facebook">
            <UIcon
              class="text-3xl hover:text-blue-500"
              dynamic
              name="i-entypo-social-facebook"
            />
          </a>
          <a class="mr-3" href="#" aria-label="Instagram">
            <UIcon
              class="text-3xl hover:text-[#fc6d45]"
              dynamic
              name="i-entypo-social-instagram"
            />
          </a>
          <a href="#" aria-label="Snapchat">
            <UIcon
              class="text-3xl hover:text-yellow-300"
              dynamic
              name="i-ph-snapchat-logo-fill"
            />
          </a>
        </div>
      </div>

      <div id="horraire" class="text-center md:text-start">
        <div class="horraire mb-5 mt-4 md:mt-0 text-2xl text-(--main-color-400)">Nos horaires</div>
        <div class="work-time flex flex-wrap flex-row justify-center md:justify-start">
          <div class="days">
            <div class="day mb-2">Lundi</div>
            <div class="day mb-2">Mardi</div>
            <div class="day mb-2">Mercredi</div>
            <div class="day mb-2">Jeudi</div>
            <div class="day mb-2">Vendredi</div>
            <div class="day mb-2">Samedi</div>
            <div class="day">Dimanche</div>
          </div>
          <div class="hours ml-5">
            <div class="day mb-2">11h-14h et 18h-23h</div>
            <div class="day mb-2">11h-14h et 18h-23h</div>
            <div class="day mb-2">11h-14h et 18h-23h</div>
            <div class="day mb-2">11h-14h et 18h-23h</div>
            <div class="day mb-2">11h-14h et 18h-23h</div>
            <div class="day mb-2">11h-14h et 18h-23h</div>
            <div class="day">Fermé</div>
          </div>
        </div>
      </div>

      <div id="pages" class="text-center md:text-start">
        <div class="page-container">
          <div class="pages mb-5 mt-4 md:mt-0 text-2xl text-(--main-color-400)">Nos pages</div>
          <div class="links flex flex-col">
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/">Accueil</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/repas">Repas</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/menus">Menus</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/boissons">Boissons</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/desserts">Desserts</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/">Nous contacter</ULink>
          </div>
        </div>
      </div>

      <div id="utils" class="text-center md:text-start">
        <div class="utils-container">
          <div class="mention mb-5 mt-4 md:mt-0 text-2xl text-(--main-color-400)">Mentions Légales</div>
          <div class="util-link flex flex-col">
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/">Tarifs livraison</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/">CGU</ULink>
            <ULink inactive-class="block mb-3 text-gray-300 hover:text-white" to="/">CGV</ULink>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
